import React, { Component } from 'react';
import { Avatar } from '@99designs/common/components/Avatar';
import { Mobile } from '@99designs/common/components/Mobile';
import { Desktop } from '@99designs/common/components/Desktop';
import { Creator, Designs } from 'apps/find-designers/propTypes';
import DesignerBranding from 'apps/find-designers/components/Listing/DesignerBranding';
import DesignerActions from 'apps/find-designers/components/Listing/DesignerActions';
import ExperienceList from 'components/Designers/ExperienceList';
import DesignerRating from './DesignerRating';
import { SearchContext } from 'apps/find-designers/components/SearchContext';
import DesignGallery from './DesignGallery';
import { userCanFavourite } from 'apps/find-designers/utils/designers';

class DesignerListItem extends Component {
    designerRating() {
        const designer = this.props.designer;
        const reviewUrl = `/profiles/${designer.userId}/about#reviews`;

        return (
            <div className="designer-list-item__details__item">
                <DesignerRating
                    reviewUrl={reviewUrl}
                    review={{
                        rating: designer.reviewRating,
                        count: designer.reviewCount,
                    }}
                />
            </div>
        );
    }

    designerExperience(categories) {
        const expertise = this.props.designer.expertiseCategories;

        return expertise.slice(0, 3).reduce((acc, cat) => {
            const category = categories.find(c => {
                return c.id === cat;
            });

            acc.push(category);
            return acc;
        }, []);
    }

    render() {
        return (
            <SearchContext.Consumer>
                {context => {
                    const designer = this.props.designer;
                    const profileUrl = `/profiles/${designer.userId}`;
                    const avatarUrl = `/avatars/users/${designer.userId}/64`;

                    return (
                        <div className="designer-list-item">
                            <a href={profileUrl} className="designer-list-item__link-overlay" />
                            <div className="designer-list-item__avatar">
                                <Mobile>
                                    <Avatar
                                        user={{
                                            avatarUrl: avatarUrl,
                                            profileUrl: profileUrl,
                                        }}
                                        variations={['extra-small']}
                                        isOnline={designer.isOnline}
                                    />
                                </Mobile>
                                <Desktop>
                                    <Avatar
                                        user={{
                                            avatarUrl: avatarUrl,
                                            profileUrl: profileUrl,
                                        }}
                                        variations={['medium']}
                                        isOnline={designer.isOnline}
                                    />
                                </Desktop>
                            </div>
                            <div className="designer-list-item__details">
                                <span className="designer-list-item__details__inner">
                                    <div className="designer-list-item__details__item">
                                        <DesignerBranding
                                            designer={designer}
                                            profileUrl={profileUrl}
                                        />
                                    </div>
                                    <div className="designer-list-item__details__item">
                                        <DesignerActions
                                            designerId={designer.userId}
                                            isFavorite={designer.flags.includes('IS_FAVORITE')}
                                            canFavorite={userCanFavourite(
                                                context.currentUser,
                                                designer
                                            )}
                                        />
                                    </div>
                                    {this.designerRating()}
                                    <div className="designer-list-item__details__item">
                                        <ExperienceList
                                            expertiseCategories={this.designerExperience(
                                                context.categories
                                            )}
                                            categories={context.categories}
                                        />
                                    </div>
                                </span>
                            </div>
                            <div className="designer-list-item__designs">
                                <DesignGallery
                                    designerId={designer.userId}
                                    designs={this.props.designs}
                                />
                            </div>
                        </div>
                    );
                }}
            </SearchContext.Consumer>
        );
    }
}

DesignerListItem.propTypes = {
    designer: Creator.isRequired,
    designs: Designs.isRequired,
};

export default DesignerListItem;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerListItem.jsx